(function () {
  const PRICE_SELECTOR = [
    '.price',
    '.price-item',
    '.tss-card__price',
    '.tss-card__compare',
    '.crc__price',
    '.crc__compare',
    '.cart-items__price',
    '.product-price-block-final-price',
    '.custom-price-block-final-price',
    '.wishlist-item__price-row',
    '[class*="__price"]',
    '[class*="-price"]'
  ].join(',');

  function stripTrailingZeros(text) {
    return text.replace(/([.,]00)(?!\d)/g, '');
  }

  function cleanPriceElement(element) {
    if (!element || element.closest('script, style')) return;

    element.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const next = stripTrailingZeros(node.textContent);
        if (next !== node.textContent) node.textContent = next;
      }
    });
  }

  function cleanPrices(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(PRICE_SELECTOR).forEach(cleanPriceElement);
  }

  document.addEventListener('DOMContentLoaded', () => cleanPrices(document));
  document.addEventListener('shopify:section:load', (event) => cleanPrices(event.target));
  document.addEventListener('variant:change', () => cleanPrices(document));
})();
